/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  AttachmentAcceptedFileTypesFragmentDoc,
  AttachmentFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type AttachmentsQueryVariables = Exact<{
  id: string
  type: string
}>

export type AttachmentsQuery = {
  __typename: "Query"
  attachments?: Array<{
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }> | null
}

export type AttachmentsByShareLinkQueryVariables = Exact<{
  projectShareID: string
  id: string
  type: string
}>

export type AttachmentsByShareLinkQuery = {
  __typename: "Query"
  attachmentsByShareLink?: Array<{
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }> | null
}

export type ProjectAttachmentsByShareLinkQueryVariables = Exact<{
  id: string
}>

export type ProjectAttachmentsByShareLinkQuery = {
  __typename: "Query"
  attachments?: Array<{
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }> | null
}

export type ProjectAttachmentCategoriesQueryVariables = Exact<{
  [key: string]: never
}>

export type ProjectAttachmentCategoriesQuery = {
  __typename: "Query"
  projectAttachmentCategories: {
    __typename: "ProjectAttachmentCategories"
    id: string
    categories: Array<{
      __typename: "SelectOptionType"
      label: string
      value: string
    }>
  }
}

export type AttachmentAcceptedFileTypesQueryVariables = Exact<{
  [key: string]: never
}>

export type AttachmentAcceptedFileTypesQuery = {
  __typename: "Query"
  attachmentAcceptedFileTypes?: Array<{
    __typename: "AttachmentAcceptedFileType"
    id: string
    createdAt: string
    updatedAt: string
    extension: string
    mimeType: string
    categories: Array<string>
  }> | null
}

export const AttachmentsDocument = gql`
  query Attachments($id: ID!, $type: String!) {
    attachments(id: $id, type: $type)
      @rest(
        type: "AttachmentType"
        path: "/project-list/{args.type}/{args.id}/attachments"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`

/**
 * __useAttachmentsQuery__
 *
 * To run a query within a React component, call `useAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  > &
    (
      | { variables: AttachmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options
  )
}
export function useAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options
  )
}
// @ts-ignore
export function useAttachmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttachmentsQuery,
    AttachmentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AttachmentsQuery, AttachmentsQueryVariables>
export function useAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsQuery,
        AttachmentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AttachmentsQuery | undefined,
  AttachmentsQueryVariables
>
export function useAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsQuery,
        AttachmentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AttachmentsQuery, AttachmentsQueryVariables>(
    AttachmentsDocument,
    options
  )
}
export type AttachmentsQueryHookResult = ReturnType<typeof useAttachmentsQuery>
export type AttachmentsLazyQueryHookResult = ReturnType<
  typeof useAttachmentsLazyQuery
>
export type AttachmentsSuspenseQueryHookResult = ReturnType<
  typeof useAttachmentsSuspenseQuery
>
export type AttachmentsQueryResult = Apollo.QueryResult<
  AttachmentsQuery,
  AttachmentsQueryVariables
>
export const AttachmentsByShareLinkDocument = gql`
  query AttachmentsByShareLink($projectShareID: ID!, $id: ID!, $type: String!) {
    attachmentsByShareLink(
      projectShareID: $projectShareID
      id: $id
      type: $type
    )
      @rest(
        type: "AttachmentType"
        path: "/project-list/share-links/{args.projectShareID}/{args.type}/{args.id}/attachments"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`

/**
 * __useAttachmentsByShareLinkQuery__
 *
 * To run a query within a React component, call `useAttachmentsByShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentsByShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentsByShareLinkQuery({
 *   variables: {
 *      projectShareID: // value for 'projectShareID'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAttachmentsByShareLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  > &
    (
      | { variables: AttachmentsByShareLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  >(AttachmentsByShareLinkDocument, options)
}
export function useAttachmentsByShareLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  >(AttachmentsByShareLinkDocument, options)
}
// @ts-ignore
export function useAttachmentsByShareLinkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AttachmentsByShareLinkQuery,
  AttachmentsByShareLinkQueryVariables
>
export function useAttachmentsByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsByShareLinkQuery,
        AttachmentsByShareLinkQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AttachmentsByShareLinkQuery | undefined,
  AttachmentsByShareLinkQueryVariables
>
export function useAttachmentsByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentsByShareLinkQuery,
        AttachmentsByShareLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AttachmentsByShareLinkQuery,
    AttachmentsByShareLinkQueryVariables
  >(AttachmentsByShareLinkDocument, options)
}
export type AttachmentsByShareLinkQueryHookResult = ReturnType<
  typeof useAttachmentsByShareLinkQuery
>
export type AttachmentsByShareLinkLazyQueryHookResult = ReturnType<
  typeof useAttachmentsByShareLinkLazyQuery
>
export type AttachmentsByShareLinkSuspenseQueryHookResult = ReturnType<
  typeof useAttachmentsByShareLinkSuspenseQuery
>
export type AttachmentsByShareLinkQueryResult = Apollo.QueryResult<
  AttachmentsByShareLinkQuery,
  AttachmentsByShareLinkQueryVariables
>
export const ProjectAttachmentsByShareLinkDocument = gql`
  query ProjectAttachmentsByShareLink($id: ID!) {
    attachments(id: $id, type: "project")
      @rest(
        type: "AttachmentType"
        path: "/project-list/share-links/{args.id}/{args.type}/attachments"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`

/**
 * __useProjectAttachmentsByShareLinkQuery__
 *
 * To run a query within a React component, call `useProjectAttachmentsByShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAttachmentsByShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAttachmentsByShareLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectAttachmentsByShareLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  > &
    (
      | {
          variables: ProjectAttachmentsByShareLinkQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  >(ProjectAttachmentsByShareLinkDocument, options)
}
export function useProjectAttachmentsByShareLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  >(ProjectAttachmentsByShareLinkDocument, options)
}
// @ts-ignore
export function useProjectAttachmentsByShareLinkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectAttachmentsByShareLinkQuery,
  ProjectAttachmentsByShareLinkQueryVariables
>
export function useProjectAttachmentsByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectAttachmentsByShareLinkQuery,
        ProjectAttachmentsByShareLinkQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectAttachmentsByShareLinkQuery | undefined,
  ProjectAttachmentsByShareLinkQueryVariables
>
export function useProjectAttachmentsByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectAttachmentsByShareLinkQuery,
        ProjectAttachmentsByShareLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectAttachmentsByShareLinkQuery,
    ProjectAttachmentsByShareLinkQueryVariables
  >(ProjectAttachmentsByShareLinkDocument, options)
}
export type ProjectAttachmentsByShareLinkQueryHookResult = ReturnType<
  typeof useProjectAttachmentsByShareLinkQuery
>
export type ProjectAttachmentsByShareLinkLazyQueryHookResult = ReturnType<
  typeof useProjectAttachmentsByShareLinkLazyQuery
>
export type ProjectAttachmentsByShareLinkSuspenseQueryHookResult = ReturnType<
  typeof useProjectAttachmentsByShareLinkSuspenseQuery
>
export type ProjectAttachmentsByShareLinkQueryResult = Apollo.QueryResult<
  ProjectAttachmentsByShareLinkQuery,
  ProjectAttachmentsByShareLinkQueryVariables
>
export const ProjectAttachmentCategoriesDocument = gql`
  query ProjectAttachmentCategories {
    projectAttachmentCategories
      @rest(
        type: "ProjectAttachmentCategories"
        path: "/project-list/attachments/categories"
      ) {
      id
      categories @type(name: "SelectOptionType") {
        label
        value
      }
    }
  }
`

/**
 * __useProjectAttachmentCategoriesQuery__
 *
 * To run a query within a React component, call `useProjectAttachmentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAttachmentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAttachmentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectAttachmentCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >(ProjectAttachmentCategoriesDocument, options)
}
export function useProjectAttachmentCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >(ProjectAttachmentCategoriesDocument, options)
}
// @ts-ignore
export function useProjectAttachmentCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectAttachmentCategoriesQuery,
  ProjectAttachmentCategoriesQueryVariables
>
export function useProjectAttachmentCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectAttachmentCategoriesQuery,
        ProjectAttachmentCategoriesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectAttachmentCategoriesQuery | undefined,
  ProjectAttachmentCategoriesQueryVariables
>
export function useProjectAttachmentCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectAttachmentCategoriesQuery,
        ProjectAttachmentCategoriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectAttachmentCategoriesQuery,
    ProjectAttachmentCategoriesQueryVariables
  >(ProjectAttachmentCategoriesDocument, options)
}
export type ProjectAttachmentCategoriesQueryHookResult = ReturnType<
  typeof useProjectAttachmentCategoriesQuery
>
export type ProjectAttachmentCategoriesLazyQueryHookResult = ReturnType<
  typeof useProjectAttachmentCategoriesLazyQuery
>
export type ProjectAttachmentCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useProjectAttachmentCategoriesSuspenseQuery
>
export type ProjectAttachmentCategoriesQueryResult = Apollo.QueryResult<
  ProjectAttachmentCategoriesQuery,
  ProjectAttachmentCategoriesQueryVariables
>
export const AttachmentAcceptedFileTypesDocument = gql`
  query AttachmentAcceptedFileTypes {
    attachmentAcceptedFileTypes
      @rest(
        type: "AttachmentAcceptedFileType"
        endpoint: "attachmentAcceptedFileTypes"
        path: "/project-list/attachments/file-extensions"
      ) {
      ...AttachmentAcceptedFileTypes
    }
  }
  ${AttachmentAcceptedFileTypesFragmentDoc}
`

/**
 * __useAttachmentAcceptedFileTypesQuery__
 *
 * To run a query within a React component, call `useAttachmentAcceptedFileTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentAcceptedFileTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentAcceptedFileTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttachmentAcceptedFileTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >(AttachmentAcceptedFileTypesDocument, options)
}
export function useAttachmentAcceptedFileTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >(AttachmentAcceptedFileTypesDocument, options)
}
// @ts-ignore
export function useAttachmentAcceptedFileTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AttachmentAcceptedFileTypesQuery,
  AttachmentAcceptedFileTypesQueryVariables
>
export function useAttachmentAcceptedFileTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentAcceptedFileTypesQuery,
        AttachmentAcceptedFileTypesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AttachmentAcceptedFileTypesQuery | undefined,
  AttachmentAcceptedFileTypesQueryVariables
>
export function useAttachmentAcceptedFileTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AttachmentAcceptedFileTypesQuery,
        AttachmentAcceptedFileTypesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AttachmentAcceptedFileTypesQuery,
    AttachmentAcceptedFileTypesQueryVariables
  >(AttachmentAcceptedFileTypesDocument, options)
}
export type AttachmentAcceptedFileTypesQueryHookResult = ReturnType<
  typeof useAttachmentAcceptedFileTypesQuery
>
export type AttachmentAcceptedFileTypesLazyQueryHookResult = ReturnType<
  typeof useAttachmentAcceptedFileTypesLazyQuery
>
export type AttachmentAcceptedFileTypesSuspenseQueryHookResult = ReturnType<
  typeof useAttachmentAcceptedFileTypesSuspenseQuery
>
export type AttachmentAcceptedFileTypesQueryResult = Apollo.QueryResult<
  AttachmentAcceptedFileTypesQuery,
  AttachmentAcceptedFileTypesQueryVariables
>
